<template>
  <div class="compass">
    <img
      src="/static/img/compass.svg"
      :style="{ transform: `rotate(${heading}deg)` }"
      alt="Compass"
    >
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  heading: {
    type: Number,
    default: 0,
  },
});
</script>

<style lang="scss" scoped>
.compass {
  width: 48px;
  height: 48px;
  margin-right: 8px;
}
</style>
